<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  @if (!displayForm) {
  <div>
    <mwp-table [tableColumns]="payStatementsColumns" [dataSource]="payStatementsMatTableData" header="Pay Statement Selection" (emitHyperLink)="loadForm($event,false)" (emitButtonSelection)="downloadTableFile($event)" />
  </div>
  }
  @if (displayForm) {
  <div>
    <!-- Employer & Employee Info -->
    <div class="content-container form-comp mb-3">
      <div class="title d-flex w-100 justify-content-between">
        <mwp-text-translate text="Employee Paystub" jsonKey="employeePaystub" />
        <div class="d-flex">
          <button class="mwp-button ignore-min-width" (click)="downloadFile(payStatementModel)">
            <mwp-text-translate text="Download" jsonKey="download" />
          </button>
        </div>
      </div>
      <div class="row content">
        <div class="col-4 d-flex flex-column mb-3">
          <div class="p-1">
            {{ payStatementModel.payStatementHeader.companyName }}
          </div>
          <div class="p-1">
            {{ payStatementModel.payStatementHeader.companyAddressOne }}
          </div>
          <div class="p-1">
            {{ payStatementModel.payStatementHeader.companyAddressTwo }}
          </div>
          <div class="p-1">
            {{ payStatementModel.payStatementHeader.companyCityState }}
          </div>
          <div class="p-1">
            Company Code: {{ payStatementModel.payStatementHeader.comCode }}
          </div>
        </div>
        <div class="col-4">
          <div class="p-1">
            {{ payStatementModel.payStatementHeader.employeeName }}
          </div>
          <div class="p-1">
            {{ payStatementModel.payStatementHeader.employeeAddressOne }}
          </div>
          <div class="p-1">
            {{ payStatementModel.payStatementHeader.employeeAddressTwo }}
          </div>
          <div class="p-1">
            {{ payStatementModel.payStatementHeader.employeeCityState }}
          </div>
          <div class="p-1">
            Employee ID: {{ payStatementModel.payStatementHeader.employeeID }}
          </div>
        </div>
        <div class="col-4">
          <div class="p-1">
            Area: {{ payStatementModel.payStatementHeader.area }}
          </div>
          <div class="p-1">
            Sub-Area: {{ payStatementModel.payStatementHeader.subArea }}
          </div>
          <div class="p-1">
            Group: {{ payStatementModel.payStatementHeader.group }}
          </div>
          <div class="p-1">
            Subgroup: {{ payStatementModel.payStatementHeader.subGroup }}
          </div>
        </div>
      </div>
    </div>

    <!-- Pay Period Info -->
    <div class="content-container form-comp mb-3">
      <div class="title d-flex w-100 ">
        <div class="col-2">
          <mwp-text-translate text="Pay Period" jsonKey="payPeriod" />
        </div>
        <div class="col-2">
          <mwp-text-translate text="Pay Date" jsonKey="payDate" />
        </div>
        <div class="col-2">
          <mwp-text-translate text="Check No." jsonKey="checkNo" />
        </div>
        <div class="col-2">
          <mwp-text-translate text="Check Amount" jsonKey="checkAmount" />
        </div>
        <div class="col-2">
          <mwp-text-translate text="Instituation" jsonKey="instituation" />
        </div>
        <div class="col-2">
          <mwp-text-translate text="Deposit Amount" jsonKey="directDepositAmount" />
        </div>
      </div>
      <div class="d-flex p-3">
        <div class="col-2">
          {{ payStatementModel.payStatementDistribution.payPeriod }}
        </div>
        <div class="col-2">
          {{ payStatementModel.payStatementDistribution.checkDate }}
        </div>
        <div class="col-2">
          {{ payStatementModel.payStatementDistribution.checkNumber }}
        </div>
        <div class="col-2">
          ${{ payStatementModel.payStatementDistribution.checkAmount.toFixed(2) }}
        </div>
        <div class="col-2">
          @for (bank of payStatementModel.payStatementDistribution.bank; track bank) {
          <div>
            {{ bank }}
          </div>
          }
        </div>
        <div class="col-2">
          @for (dda of payStatementModel.payStatementDistribution.directDepositAmount; track dda) {
          <div>
            {{ dda }}
          </div>
          }
        </div>
      </div>
    </div>

    <!-- Pay Amounts -->
    <div class="content-container form-comp mb-3">
      <div class="title d-flex w-100 ">
        <div class="col-2">
          <mwp-text-translate text="Gross Pay" jsonKey="grossPay" />
        </div>
        <div class="col-3">
          <mwp-text-translate text="Pre-Tax Deductions" jsonKey="preTaxDeductions" />
        </div>
        <div class="col-2">
          <mwp-text-translate text="Taxes" jsonKey="taxes" />
        </div>
        <div class="col-3">
          <mwp-text-translate text="Post-Tax Deductions" jsonKey="postTaxDeductions" />
        </div>
        <div class="col-2">
          <mwp-text-translate text="Net Pay" jsonKey="netPay" />
        </div>
      </div>
      <div class="d-flex p-3">
        <div class="col-2">
          ${{ payStatementModel.grossPay.toFixed(2) }}
        </div>
        <div class="col-3">-${{ payStatementModel.preTax.toFixed(2) }}</div>
        <div class="col-2">-${{ payStatementModel.totalTax.toFixed(2) }}</div>
        <div class="col-3">-${{ payStatementModel.postTax.toFixed(2) }}</div>
        <div class="col-2">${{ payStatementModel.netPay.toFixed(2) }}</div>
      </div>
    </div>

    <div class="d-flex me-3">
      <div class="col-6 me-3">
        <!-- Earnings -->
        <div class="content-container form-comp mb-3">
          <div class="title d-flex w-100 justify-content-between">
            <div class="col-2">
              <mwp-text-translate text="Earnings" jsonKey="earnings" />
            </div>
            <div class="col-1 text-end">
              <mwp-text-translate text="Rate" jsonKey="rate" />
            </div>
            <div class="col-2 text-end">
              <mwp-text-translate text="Hours" jsonKey="hours" />
            </div>
            <div class="col-2 text-end">
              <mwp-text-translate text="Amount" jsonKey="amount" />
            </div>
            <div class="col-2 text-end">
              <mwp-text-translate text="YTD" jsonKey="ytd" />
            </div>
            @if(hasPSEAdjustmentPeriod){
            <div class="col-3 text-end">
              <mwp-text-translate text="Adjustment Period" jsonKey="adjustmentPeriod" />
            </div>
            }
          </div>
          @for (pse of payStatementModel.payStatementEarnings; track pse) {
          <div class="d-flex content paystub-table-body py-3 align-items-center justify-content-between">
            <div class="col-2">{{ pse.earningCode }}</div>
            <div class="col-1 text-end">{{ pse.rate }}</div>
            <div class="col-2 text-end">{{ pse.hours }}</div>
            <div class="col-2 text-end">${{ pse.amount.toFixed(2) }}</div>
            <div class="col-2 text-end">${{ pse.ytdAmount.toFixed(2) }}</div>
            @if(hasPSEAdjustmentPeriod){
            <div class="col-3 text-center">{{ pse.adjustmentPeriod }}</div>
            }
          </div>
          }
          <div class="content paystub-table-total d-flex py-3 align-items-center">
            <div class="col-2">
              <mwp-text-translate text="TOTAL" jsonKey="total" />
            </div>
            <div class="col-1"></div>
            <div class="col-2 text-end">{{ payStatementModel.earningHoursWorkedTotal.toFixed(2) }}</div>
            <div class="col-2 text-end">${{ payStatementModel.grossPay.toFixed(2) }}</div>
            <div class="col-2 text-end">${{ payStatementModel.earningsTotalYTD.toFixed(2) }}</div>
            @if(hasPSEAdjustmentPeriod){
            <div class="col-3"></div>
            }
          </div>
        </div>

        <!-- Deductions -->
        <div class="content-container form-comp mb-3">
          <div class="title d-flex w-100 justify-content-between ">
            <div class="col-3">
              <mwp-text-translate text="Deductions" jsonKey="deductions" />
            </div>
            <div class="col-2">
              <mwp-text-translate text="Tax Status" jsonKey="taxStatus" />
            </div>
            <div class="col-2 text-end">
              <mwp-text-translate text="Amount" jsonKey="amount" />
            </div>
            <div class="col-2 text-end">
              <mwp-text-translate text="YTD" jsonKey="ytd" />
            </div>
            @if(hasPSDAdjustmentPeriod){
            <div class="col-3 text-end">
              <mwp-text-translate text="Adjustment Period" jsonKey="adjustmentPeriod" />
            </div> }
          </div>
          @for (psd of payStatementModel.payStatementDeductions; track psd) {
          <div class="d-flex content paystub-table-body py-3 align-items-center justify-content-between">
            <div class="col-3">{{ psd.deductionCode }}</div>
            <div class="col-2">{{ psd.taxStatus }}</div>
            <div class="col-2 text-end">${{ psd.amount.toFixed(2) }}</div>
            <div class="col-2 text-end">${{ psd.ytdAmount.toFixed(2) }}</div>
            @if(hasPSDAdjustmentPeriod){
            <div class="col-3 text-center">{{ psd.adjustmentPeriod }}</div> }
          </div>
          }
          <div class="content paystub-table-total d-flex py-3 align-items-center">
            <div class="col-3">
              <mwp-text-translate text="TOTAL" jsonKey="total" />
            </div>
            <div class="col-2"></div>
            <div class="col-2 text-end">${{ payStatementModel.deductionsTotal.toFixed(2) }}</div>
            <div class="col-2 text-end">${{ payStatementModel.deductionsTotalYTD.toFixed(2) }}</div>
            @if(hasPSEAdjustmentPeriod){
            <div class="col-3"></div> }
          </div>
        </div>
      </div>


      <div class="col-6 ">
        <!-- Taxes -->
        <div class="content-container form-comp mb-3">
          <div class="title d-flex w-100 ">
            <div class="col-4">
              <mwp-text-translate text="Taxes" jsonKey="taxes" />
            </div>
            <div class="col-4 text-end">
              <mwp-text-translate text="Amount" jsonKey="amount" />
            </div>
            <div class="col-4 text-end">
              <mwp-text-translate text="YTD" jsonKey="ytd" />
            </div>
          </div>
          @for (pst of payStatementModel.payStatementTaxes; track pst) {
          <div class="d-flex content paystub-table-body py-3 align-items-center">
            <div class="col-4">{{ pst.taxCode }}</div>
            <div class="col-4 text-end">${{ pst.amount.toFixed(2) }}</div>
            <div class="col-4 text-end">${{ pst.ytdAmount.toFixed(2) }}</div>
          </div>
          }
          <div class="content paystub-table-total d-flex py-3 align-items-center ">
            <div class="col-4">
              <mwp-text-translate text="TOTAL" jsonKey="total" />
            </div>
            <div class="col-4 text-end">${{ payStatementModel.totalTax.toFixed(2) }}</div>
            <div class="col-4 text-end">${{ payStatementModel.taxesTotalYTD.toFixed(2) }}</div>
          </div>
        </div>

        <!-- Time-Off -->
        <div class="content-container form-comp mb-3">
          <div class="title d-flex w-100 ">
            <div class="col-3">
              <mwp-text-translate text="Time-Off" jsonKey="timeOff" />
            </div>
            <div class="col-3 text-end">
              <mwp-text-translate text="Accrued" jsonKey="accrued" />
            </div>
            <div class="col-3 text-end">
              <mwp-text-translate text="Used" jsonKey="used" />
            </div>
            <div class="col-3 text-end">
              <mwp-text-translate text="Available" jsonKey="available" />
            </div>
          </div>
          @for (psl of payStatementModel.payStatementLeave; track psl) {
          <div class="d-flex content paystub-table-body py-3 align-items-center">
            <div class="col-3">{{ psl.leaveCode }}</div>
            <div class="col-3 text-end">{{ psl.hourAccrued.toFixed(2) }}</div>
            <div class="col-3 text-end">{{ psl.hourUsed.toFixed(2) }}</div>
            <div class="col-3 text-end">{{ psl.hourAvailable.toFixed(2) }}</div>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end w-100 mt-3">
      <button (click)="closeForm()" class="mwp-button">
        <mwp-text-translate text="Return" jsonKey="return" />
      </button>
    </div>
  </div>
  }
</div>